module.exports = __webpack_public_path__ + "static/media/icon_dash_board.532b23b3.svg";